import { makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import { School } from "@backend-types";
import axios from "../../../../services/axios";
import { UsersManagementProps } from "../../../../pages/v2/UsersPage";
import { logger } from "../../../../services/logger";
import { Button } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  newPosOfDialog: {
    paddingTop: "32px",
    paddingBottom: "32px",
    paddingLeft: "40px",
    paddingRight: "40px",
    width: "35%",
    minWidth: "400px",
    minHeight: "200px",
    backgroundColor: "#FFF8F2",
    border: "1px solid #FD8211",
    boxShadow: "0px 3px 20px #00000014",
    borderRadius: "20px",
  },
  dialogTitle: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#191919",
    marginBottom: "24px",
  },
  dialogText: {
    fontSize: "15px",
    color: "#5D5D5D",
    marginBottom: "33px",
  },
  label: {
    fontWeight: "bold",
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "16px",
  },
}));

export interface SchoolDeletePromptProps extends UsersManagementProps {
  promptOpen: boolean;
  promptOnClose: () => void;
  school: School | undefined;
}

export const SchoolDeletePrompt = (props: SchoolDeletePromptProps) => {
  const classes = useStyles();

  const { promptOnClose, promptOpen, school } = props;

  const deleteSchool = async (user: School | undefined) => {
    if (!user) return;
    const id = props?.school?.id;
    const name = props?.school?.name;

    if (!name || !id) return;
    axios
      .delete("/school", {
        data: { id },
      })
      .then((res) => {
        const message = `Delete school, ${name}, result: Success.`;
        props.onDelete({ message, severity: "success" });
      })
      .catch((err) => {
        logger.error(err);
        const message = `Delete school, ${name}, result: Failed.`;
        props.onDelete({ message, severity: "error" });
      });
    promptOnClose();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      classes={{
        paper: classes.newPosOfDialog,
      }}
      onClose={promptOnClose}
      aria-labelledby="simple-dialog-title"
      open={promptOpen}>
      <div className={classes.dialogTitle}>
        Are you sure you want to delete the following school? This will effect any users
        associated with the school.
      </div>
      <div className={classes.dialogText}>
        <p>
          <span className={classes.label}>Name:</span> {school?.name}
        </p>
        <p>
          <span className={classes.label}>District:</span> {school?.district}
        </p>
      </div>
      <div className={classes.buttonWrapper}>
        <Button variant="outlined" size="medium" onClick={promptOnClose}>
          No
        </Button>
        <Button
          variant="contained"
          size="medium"
          onClick={(event) => deleteSchool(school)}>
          Yes, delete this school
        </Button>
      </div>
    </Dialog>
  );
};
